import { styled, Theme } from '@mui/material/styles';

export const ContentContainer = styled('div')`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0 20px 20px 20px;
    
    @media (max-width: 768px) {
        padding: 0 16px 16px 16px;
        max-height: 70vh;
        overflow-y: auto;
        
        .MuiTabs-root {
            margin: 0 -16px;
        }
        
        .MuiTab-root {
            min-width: auto;
            padding: 8px 12px;
        }
        
        .MuiTabs-scrollButtons {
            background: rgba(255, 255, 255, 0.9);
            border-radius: ${({ theme }) => theme.shape.borderRadius}px;
        }
    }
`

export const Label = styled('div')`
    margin-top: 10px;
`;

export const UrlContainer = styled('div')`
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    width: 100%;
    max-width: 100%;
    justify-content: flex-end;
    
    @media (max-width: 768px) {
        margin: 15px 0;
    }
`;

export const FileContainer = styled('div')`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    justify-content: flex-end;
    
    @media (max-width: 768px) {
        margin: 15px 0;
    }
`;

export const getDropzoneBaseStyle = (theme: Theme) => ({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: theme.palette.grey[200],
    borderStyle: 'dashed',
    backgroundColor: theme.palette.grey[50],
    color: theme.palette.grey[400],
    outline: 'none',
    transition: 'border .24s ease-in-out'
});

export const getDropzoneMobileBaseStyle = (theme: Theme) => ({
    ...getDropzoneBaseStyle(theme),
    padding: '16px',
    fontSize: '14px',
    minHeight: '120px'
});

export const getDropzoneFocusedStyle = (theme: Theme) => ({
    borderColor: theme.palette.info.main,
});

export const getDropzoneAcceptStyle = (theme: Theme) => ({
    borderColor: theme.palette.success.main,
});

export const getDropzoneRejectStyle = (theme: Theme) => ({
    borderColor: theme.palette.error.main,
});

export const Cont = styled('div')`
    flex-direction: column
`;

export const ErrorMessage = styled('div')`
    max-width: 100%;
    word-wrap: break-word;
    text-align: center;
    margin-top: 10px;
    font-size: 14px;
    
    @media (max-width: 768px) {
        font-size: 12px;
        margin-top: 8px;
    }
`;

export const MobileTabContainer = styled('div')`
    margin-left: 15px;
    margin-right: 15px;
    @media (max-width: 768px) {
        .MuiTab-root {
            text-transform: none;
            font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
            min-width: auto;
            flex: 1;
            max-width: none;
            width: 100%;
        }
    }
`;
